import { Group, Paper, rem, Stack, Text } from '@mantine/core';
import { Outlet, useMatchRoute, useParams } from '@tanstack/react-router';
import { FC } from 'react';

import { ManagePointsForm } from '../../components/forms/manage-points-form';
import { OrderDetails } from '../../components/order-details';
import { OrderNav } from '../../components/order-nav';
import { useOrderPage } from '../../hooks/use-order-page';

import { FullMainHeight } from '@ui';

export const OrderPage: FC = () => {
  const { id } = useParams({
    from: '/_app/_admin/orders_/$id',
  });
  const matchRoute = useMatchRoute();
  const { order } = useOrderPage();

  const isOnTable = matchRoute({ to: '/orders/$id/points' });

  return (
    <FullMainHeight.Root>
      <FullMainHeight.FlexContent>
        <FullMainHeight.Sidebar>
          <Stack>
            <Paper withBorder>
              <Stack gap={0} h={rem(36)}>
                <Text fw={600} lh={1} size="lg">
                  {order.data?.name}
                </Text>
                <Group gap="xs">
                  <Text size="sm">
                    {order.data?.sampler?.last_name}{' '}
                    {order.data?.sampler?.first_name}
                  </Text>
                </Group>
              </Stack>
            </Paper>

            <Paper p="lg" withBorder>
              <OrderDetails />
            </Paper>

            {isOnTable ? (
              <Paper>
                <ManagePointsForm orderId={Number(id)} />
              </Paper>
            ) : null}
          </Stack>
        </FullMainHeight.Sidebar>
        <Stack h="100%" style={{ overflow: 'hidden' }}>
          <Paper flex="0 0 auto" withBorder>
            <OrderNav />
          </Paper>
          <Outlet />
        </Stack>
      </FullMainHeight.FlexContent>
    </FullMainHeight.Root>
  );
};
